// Convert lat/lon to Maidenhead Grid Locator
export function latLonToGrid(lat, lon) {
  var lng = lon + 180;
  var lt = lat + 90;
  var a = String.fromCharCode(65 + Math.floor(lng / 20));
  var b = String.fromCharCode(65 + Math.floor(lt / 10));
  var c = Math.floor((lng % 20) / 2);
  var d = Math.floor(lt % 10);
  var e = String.fromCharCode(97 + Math.floor((lng % 2) * 12));
  var f = String.fromCharCode(97 + Math.floor((lt % 1) * 24));
  return a + b + c + d + e + f;
}

// Get grid from IP geolocation (free API, no key needed)
export function getGridFromIP() {
  return fetch("https://ipapi.co/json/")
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.latitude && data.longitude) {
        return {
          grid: latLonToGrid(data.latitude, data.longitude),
          city: data.city || "",
          country: data.country_name || "",
          lat: data.latitude,
          lon: data.longitude
        };
      }
      return null;
    })
    .catch(function() {
      return fetch("http://ip-api.com/json/?fields=lat,lon,city,country")
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.lat && data.lon) {
            return {
              grid: latLonToGrid(data.lat, data.lon),
              city: data.city || "",
              country: data.country || "",
              lat: data.lat,
              lon: data.lon
            };
          }
          return null;
        })
        .catch(function() { return null; });
    });
}
